/**
 * The strip a scrollable list shows at either end. Its `::before` reaches a strip's height past the
 * list's edge, so hovering just outside the list keeps it scrolling.
 */
export const scrollArrowClass = [
  'text-foreground-placeholder bg-background-overlay corner-smooth z-[1] flex h-4 w-full cursor-default items-center justify-center rounded-md text-center text-xs',
  "before:absolute before:left-0 before:h-full before:w-full before:content-['']",
  'data-[direction=up]:top-0 data-[direction=up]:before:top-[-100%]',
  'data-[direction=down]:bottom-0 data-[direction=down]:before:bottom-[-100%]',
].join(' ')
